import React from 'react';
import ReactDOM from 'react-dom';
import "bootstrap/dist/css/bootstrap.css"
import './index.css';
import './theme.css';
import Routes from './components/Routes'
import VersionNueva from './components/layout/VersionNueva'
import '@fortawesome/fontawesome-free/css/all.min.css'; 



ReactDOM.render(
  <React.StrictMode>
    <VersionNueva />
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

